import { IDataPrepareInvoice } from "shared/models/store/IDataPrepareInvoice"


export const convertDataPrepareInvoice = (option: IDataPrepareInvoice) => {
    return {
            paymentLineId: option.paymentLineId,
            recoveryFeeValue: option.recoveryFeeValue,
            valuePaidByTheUser: option.valuePaidByTheUser,
            documentType: option.documentType,
            documentNumber: option.documentNumber,
            name: option.name,
            lastname: option.lastname,
            phoneOne: (() => {
                const cleaned = option.phoneOne.replace(/^\+57/, '');
                if (cleaned.length > 10) {
                    return cleaned.substring(6, 13);
                }
                return cleaned;
            })(),
            phoneTwo: (() => {
                const cleaned = option.phoneTwo.replace(/^\+57/, '');
                if (cleaned.length > 10) {
                    return cleaned.substring(6, 13);
                }
                return cleaned;
            })(),
            email: option.email,
            province: option.province.id,
            city: option.city.id,
            address: option.address,
            namePatientSeen: option.patientName,
            LastNamePatientAttended: option.patientLastName,
            typeDocumentPatientSeen: option.patientTypeId,
            documentNumberPatientSeen: option.patientDocumentNumber,
            isRecoveryFee: option.isRecoveryFee,
            isUnderage: option.isYounger,
            id: option.id,
            file: {
                id: option.attachment.id,
                originalName: option.attachment.originalName,
                path: option.attachment.path
            },
    }
}